export default __webpack_public_path__ + "static/media/right_trees.b056a915.svg";